import * as React from 'react';
import { HotelViewModel } from 'models';

export interface SupportingMessagesProps {
  supportingMessages: HotelViewModel['supportingMessages'];
}

export const SupportingMessages: React.FunctionComponent<SupportingMessagesProps> = ({ supportingMessages }) => (
  <React.Fragment>
    {supportingMessages &&
      Array.isArray(supportingMessages.slice()) &&
      supportingMessages.map((supportingMessage, index) => (
        <div className="supporting-message uitk-cell pwa-theme--grey-700 uitk-type-right uitk-type-100" key={`supportingMessage-${index}`}>
          {supportingMessage}
        </div>
      ))}
  </React.Fragment>
);
